import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MenuContext from '../../store/MenuContext';
import TestInfoClasses from '../Tests/TestInfo.module.css';


const FilterUsers = ({ handleUpdate, tableForm: TF }) => {
  const navigate = useNavigate();

  // Cancel logic
  const cancelFilter1 = () => {
    sessionStorage.removeItem("Filter1");
    sessionStorage.removeItem("Filter2");
    navigate("/noService");
  };

  // Filter 1
  const [filter1Options, setFilter1Options] = useState([]);
  const [selectedFilter1, setSelectedFilter1] = useState("");

  useEffect(() => {
    if (TF?.[0]?.Select) {
      setFilter1Options(TF[0].Select);
    }
  }, [TF]);
console.log(TF);
  const handleFilter1Change = (event) => {
    const rawValue = event.target.value;
	const value = rawValue.trim();

	if (!value || value === 'null' || value === 'undefined' || value.includes('\x00')) {
		console.log('canceling');
		cancelFilter1();
		return;
	}
    sessionStorage.setItem("Filter1", value);
	sessionStorage.setItem(TF[0]['DBColumn'],value)
    sessionStorage.removeItem("Filter2");
    setSelectedFilter1(value);
  };

  // Filter 2
  const [showFilter2, setShowFilter2] = useState(false);
  const [filter2Options, setFilter2Options] = useState([]);
  const [selectedFilter2, setSelectedFilter2] = useState("");

  useEffect(() => {
    if (!selectedFilter1 ) return;

    const secondFilter = TF[1];
    if (secondFilter?.Display === true && secondFilter?.Select) {
      const matchingOptions = secondFilter.Select.filter(option =>
        option.Code.split(":")[1]?.toUpperCase() === selectedFilter1.toUpperCase()
      );
      setFilter2Options(matchingOptions);

      if (matchingOptions.length > 0) {
        setShowFilter2(true);
      } else {
        setShowFilter2(false);
        handleUpdate("done");
      }
    } else {
      setShowFilter2(false);
      handleUpdate("done");
    }
  }, [selectedFilter1, TF]);

  const handleFilter2Change = (event) => {
    const value = event.target.value;
    sessionStorage.setItem("Filter2", value);
    setSelectedFilter2(value);
	sessionStorage.setItem(TF[1]['DBColumn'],value)
    handleUpdate("done");
  };

  return (
    <div className={TestInfoClasses.testInfo}>
      <div className={TestInfoClasses.testInfoContent}>
        <div className={TestInfoClasses.modalArea}>
          {/* Filter 1 */}
          {TF?.[0]?.Label && <span>{TF[0].Label}</span>}
		  {TF?.[0]?.FieldType ==='select' &&
			  <select value={selectedFilter1} onChange={handleFilter1Change}>
				<option value="">--Select--</option>
				{filter1Options.map(option => (
				  <option key={option.Code} value={option.Code}>
					{option.Description}
				  </option>
				))}
				</select>
			  }
		  {TF?.[0]?.FieldType === 'radiobutton' && (
			  <>
			    <br/>
				{filter1Options.map(option => (
				  <label key={option.Code}>
					<input
					  type="radio"
					  name="filter1"
					  value={option.Code}
					  onChange={handleFilter1Change}
					/>
					{option.Description}
				  </label>
				))}
			  </>
			)}

          {/* Filter 2 (conditional) */}
          {showFilter2 && (
            <>
              <br /><br />
              {TF?.[1]?.Label && <span>{TF[1].Label}</span>}
              <select value={selectedFilter2} onChange={handleFilter2Change}>
                <option value="">--Select--</option>
                {filter2Options.map(option => (
                  <option key={option.Code} value={option.Code}>
                    {option.Description}
                  </option>
				))}
			  </select>
			</>
		  )}
          {/* Cancel button */}
          <br /><br />
          <button className={TestInfoClasses.buttonDarkBlue} onClick={cancelFilter1}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterUsers;
